module.exports = __webpack_public_path__ + "static/15-db5e9c2e60faafb29de3f7728d1b75b2.jpg";